import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/dreamconnect/dreamconnect/node_modules/next/dist/client/app-dir/link.js");
